'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const OutputFileInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;

  & > * {
  }
`;
